// Accept one phone number, never concatenate multiple contact numbers.
export const getWhatsAppUrl = (value) => {
  const raw = String(value || "").trim();
  if (!raw || !/^\+?[\d\s().-]+$/.test(raw)) return "";
  let number = raw.replace(/\D/g, "");
  if (number.startsWith("00")) number = number.slice(2);
  else if (number.startsWith("0")) number = `62${number.slice(1)}`;
  else if (number.startsWith("8") && !raw.startsWith("+")) number = `62${number}`;
  if (!/^[1-9]\d{7,14}$/.test(number)) return "";
  return `https://wa.me/${number}`;
};
